var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAktifyChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#2E2E2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8988 4.5L17.4091 16.1364H14.1704L13.7205 14.8843H10.0099L9.53738 16.1364H6.59091L11.8988 4.5ZM10.8645 12.6524H12.9338L11.8988 9.85121L10.8645 12.6524Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.59091,
    y: 18.3182,
    width: 10.8182,
    height: 2.18182,
    fill: "#DD2424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAktifyChatIcon);
export default __webpack_public_path__ + "static/media/aktify-chat-icon.95a6a938202e9cb4197c17d54138a844.svg";
export { ForwardRef as ReactComponent };